import { PropertyFilterProps } from "@amzn/awsui-components-react/polaris/property-filter/interfaces";

export const convertTokensToPropertyFilter = (tokens: ReadonlyArray<PropertyFilterProps.Token>): { [key: string]: string[] } => {
    const result: { [key: string]: string[] } = {};

    tokens.forEach(i => {
        const key = i.propertyKey;
        if (!key) return;
        if (Object.keys(result).includes(key)) {
            result[key].push(i.value);
        } else {
            result[key] = [i.value];
        }
    });

    return result;
}
